import { Subscriptions } from "@bezoned/shared/features/subscriptions/subscriptions.constants.js";

import { useSubscription } from "../../subscription/subscription.context.js";
import { TeamCreateFlow } from "./team-create-flow.js";
import type { useCreateTeamDialog } from "./use-create-team-dialog.js";

export const TeamCreateRegularDialog = (
  props: ReturnType<typeof useCreateTeamDialog>["props"]
) => {
  const { planId } = useSubscription();
  const isStarter = planId === Subscriptions.StarterPlan;

  return (
    <TeamCreateFlow
      isStarter={isStarter}
      props={props}
      submitAfterGeneral={false}
      wizardSteps={
        isStarter ? ["General", "Members"] : ["General", "Members", "Theme"]
      }
    />
  );
};
